import { Injectable, OnDestroy, OnInit } from "@angular/core";
import { Subject, Subscription } from "rxjs";
import { Avis } from "../avis/models/Avis";

@Injectable()
export class AvisService implements OnInit {

    private avis: Avis[] = [
        {
            id: 0,
            summary: "Une perte de 4 kilos",
            author: "Séverine",
            job: "Délégué pharmaceutique",
            age: 44,
            note: 5,
            content:"Après 6 mois de cours dans la bonne humeur avec Jordan une fois par semaine  j'ai pu constaté avec plaisir une taille en moins dans mes vêtements et une perte de 4 kilos. Des cours hyper motivants et un suivi très personalisé. Même mon mari m'accompagne!",
        },
        {
            id: 1,
            summary: "Cours adaptés à mon sport",
            author: "Julien",
            job: "Entraineur/joueur de foot",
            age: 34,
            note: 5,
            content:"J'ai senti assez rapidement du mieux après mes séances de coaching je n'étais pas un adepte des cours de musculation mais celle ci sont adapté à ma pratique du football et je me sent Bcp mieux sur le terrain après les séances.",
        },
        {
            id: 2,
            summary: "Professionnel et sérieux",
            author: "Romain",
            job: "Marin pompier",
            age: 25,
            note: 5,
            content:"Salut Jordan, depuis le 1er février 2021 je t'ai choisi pour me faire progresser pour mon concours de Sapeurs-pompiers Professionnels. J'ai augmenté mes temps à ce jour novembre 2021 grâce à ta connaissance en sport et ton savoir-faire ! Tu es professionnel dans ton travail et sérieux merci encore",
        },
        {
            id: 3,
            summary: "Un coach au TOP !",
            author: "Laetitia",
            job: "vendeuse prêt à porter",
            age: 32,
            note: 5,
            content:"Des coachings qui s'adaptent à la morphologie, au niveau sportif et à l'objectif de chaque personnes. Des séances alliant force et cardio qui fait qu'on ne rentre pas dans une routine mais chaque séances est une surprise.<br> J'ai réussi à perdre en 6 mois grâce à 2 séances par semaine 30 kg même si à l'heure d'aujourd'hui, à cause des confinements , j'ai repris , mon coach est toujours là pour me motiver à nouveau et reprendre notre programme. Il suit mon programme alimentaire et ma perte de poids sur la balance donc on se sent vraiment épaulé.<br>Ne pas hésitez à faire appel à Jordan pour un coaching personnalisé , adapté et avec de vrais résultats !",
        },
        {
            id: 5,
            summary: "Jordan s'adapte à son public !",
            author: "Frédéric",
            job: "resp agro-alimentaire",
            age: 39,
            note: 5,
            content:"<strong>Alors mon ressenti ?</strong><br>Ca aide à aller plus loin dans la souffrance, quand on pense qu'on en peux plus... c'est faux ! On peut encore.<br>Jordan s'adapte à mes besoins, alterne des exos que je maîtrise et d'autres que j'apprends.<br>En faisant du coaching on comprend ce que c'est du sport intense. Car c'est ça que je recherche. Et comme je n'ai pas bcp de temps, bébé oblige, c'est parfait. Mais attention Jordan s'adapte à son public !<br><br><strong>Mes évolutions ?</strong><br>J ai perdu 10cm de tour de taille et 8cm de tour de hanches + mes épaules se sont développées. Mais surtout je me sens bien dans mon corps dans ma tête, ce qui reste le plus important. Et enfin, après une vie d'un poids fluctuant, il est enfin stable depuis 2 ans.<br>Et niveau santé je sens que je suis plus performant dans certains sports que je pratique moins.<br>Exemple, j'ai été rouler en VTT pour la première fois en 2 ans et mon ami qui a l'habitude de rouler avait la langue pendante et m'a supplié de rentrer après 30km et de belles montées.<br>Même situation avec la course MK6, que j'ai fini sans courbatures et avec le cœur qui n'est pas monté trop haut dans les tours.",
        },
        {
            id: 6,
            summary: "Mr Krstic est un coach au top",
            author: "Michel",
            job: "Producteur de spiruline",
            age: 30,
            note: 5,
            content:"Il est souriant, compétent et passionné. Il m'a coaché quand j'avais une tendinite à l'épaule m'a aidé à me rétablir et à ne plus avoir de douleurs. Il m'a beaucoup fait progresser sur l' endurance et la force. Tout ça dans la joie de vivre.",
        },
        {
            id: 6,
            summary: "Son seul défaut: sa moustache",
            author: "Jean-François",
            job: "Cadre dans l'alimentaire",
            age: 38,
            note: 5,
            content:"Trainings adaptés au niveau de chacun ce qui est plutôt pas mal et permet de progresser step by step, le tout dans une super ambiance avec un coach à l'écoute des objectifs de chacun.<br>Seul défaut du coach : sa moustache !!! Lol",
        },
        {
            id: 7,
            summary: "Je ne pourrais que le recommander",
            author: "Antoine",
            job: "Directeur d'agence bancaire",
            age: 38,
            note: 5,
            content:"Le coaching avec Jordan a débuté depuis 7 mois. Il est à l'écoute des besoins et il m'aide à atteindre mes objectifs et à repousser mes limites jours après jours.<br>Au delà de son coaching très professionnel, Jordan fait la différence par une approche très humaine. Toujours de bonne humeur, la séance est aussi un moment de détente, un instant pour souffler, échanger et surtout... rire et danser (entre deux exercices)... C'est notre moment pour oublier le stress du quotidien.<br>Ma compagne participe elle aussi aux séances, et Jordan a su integer ses objectifs personnels tout en y intégrant des exercices de couple. Je ne pourrais que le recommander.<br><br>Ps : j'adore ses shorts moule-fesses ! Jolie petit cul",
        },
        {
            id: 4,
            summary: "Le coaching est au top",
            author: "Verane",
            job: "Restauratrice",
            age: null,
            note: 5,
            content:"Le coaching est au top, les séances sont toujours différentes et aussi intense.<br>Il y a une très bonne ambiance, on se sent tout de suite à l’aise et le coach en lui même vous motive bien comme il faut, il est toujours à l’écoute.<br>De ce qui est de mon évolution, j’ai gagné en mental, pour le physique il faut être patient comme dans n’importe quelle autre pratique.<br>Grâce à la reprise du sport et notamment les séances en cross fit avec le coach, ça a était bénéfique pour moi, car c’est beaucoup plus vivant et plus familial qu’une salle de sport et je me sens moins fatiguée et stressée qu’avant, j’ai plus de pêche aux files des séances.<br>Puis on va pas se mentir faire du sport est bénéfique dans tous les domaines.",
        },
    ];

    avisSubject= new Subject<Avis[]>();

    ngOnInit() {
        this.avis = this.getAllAvisFromServer();
    }

    /**
     * Faire emmetre une copie du tableau des avis
     */
    emmitAvisSubject() {
        this.avisSubject.next(this.avis.slice());
    }

    getAvis() {
        return this.avis;
    }

    getAllAvisFromServer(): Avis[] {
        return null;
    }

    saveAvisToServer() {
    }
}
